import Head from "next/head";
import { useRouter } from "next/router";

import Newsletter from "../components/Newsletter";
import { FlashPCBPage } from "../models/page";

function getSource(source: string | string[] | undefined) {
  if (Array.isArray(source)) {
    if (source.length > 0) {
      return source[0];
    } else {
      return undefined;
    }
  }
  return source;
}

const NewsletterPage: FlashPCBPage = () => {
  const router = useRouter();

  return (
    <>
      <Head>
        <title>FlashPCB Newsletter</title>
        <meta name="description" content="Sign up for our newsletter" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <Newsletter source={getSource(router.query.source)} />
    </>
  );
};

export default NewsletterPage;
